module.exports = __webpack_public_path__ + "static/media/Prinplup_gaussian2.411a7769.png";